module.exports = __webpack_public_path__ + "img/double_right_arrows.4242098e.svg";